
namespace TabAurous.Reports {
    import fld = TabAurous.Stock.StockItemRow.Fields;
    @Serenity.Decorators.registerClass()
    export class OwnStoneGrid extends Serenity.EntityGrid<TabAurous.Stock.StockItemRow, any> {
        protected getColumnsKey() { return 'Stock.StoneStock'; } 
        protected getIdProperty() { return TabAurous.Stock.StockItemRow.idProperty; }
        protected getInsertPermission() { return TabAurous.Stock.StockItemRow.insertPermission; }
        protected getLocalTextPrefix() { return TabAurous.Stock.StockItemRow.localTextPrefix; }
        protected getService() { return TabAurous.Stock.OwnStoneStockService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
            this.addDateRangeFilter("VoucherDate", "Date");
            this.setTitle(""); 
        }
        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid();
            //grid.registerPlugin(this.autoSize);
            grid.registerPlugin(new Slick.Data.GroupItemMetadataProvider());
            return grid;
        }
      
        protected getButtons(): Serenity.ToolButton[] {
            super.getButtons();
             
            return [({
                title: 'Print',
                icon: 'fa fa-print text-blue',
                //icon: 'fa-cloud-download',
                onClick: () => {
                    
                    Common.ReportHelper.execute({
                        reportKey: 'Stock.MetalMovementRegister',
                        params: {
                            CompanyIds: this.view.params.CompanyIds,
                            FinIds: this.view.params.FinancialYearIds,
                            VendorIds: this.view.params.VendorIds,
                            date:this.view.params.Criteria
                        }
                    });
                }
            }
            ), (Serenity.ColumnPickerDialog.createToolButton(this as any))]
        }
    }
}